import React from 'react';
import { Box } from '@heycater/design-system';
import { useInView } from 'react-intersection-observer';

export const StickyBottomSection = ({
  children,
  height,
  isFloating,
  ...restProps
}) => {
  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        flexGrow="1"
        bottom="0"
        left="0"
        right="0"
        position={isFloating ? 'fixed' : 'relative'}
        {...restProps}
      >
        {children}
      </Box>

      {/* 
          Placeholder, to avoid layout shifts.
          so if the content starts floating, 
          it's original space is kept in the layout 
        */}
      {isFloating && <div style={{ height: `${height}px` }} />}
    </>
  );
};

export function useStickyBottomSection() {
  const { inView, ref, entry: intersectionEntry } = useInView({
    threshold: 1,
  });

  const floatingSectionHeight =
    intersectionEntry?.boundingClientRect?.height || 0;

  const isUnderViewport = intersectionEntry
    ? intersectionEntry.boundingClientRect?.y > 0
    : true;

  const isFloating = !inView && isUnderViewport;
  return { height: floatingSectionHeight, isFloating, ref };
}
